import { FormattedNamedOffender } from './formattedNamedOffender.type';

export const removeLinkedExternalNamedOffenders = (
  namedOffenders: FormattedNamedOffender[],
) => {
  const linkedOffenderIds = namedOffenders
    .filter((offender) => offender.linkedOffenderId)
    .map((offender) => offender.linkedOffenderId);

  return namedOffenders.filter(
    (offender) => !linkedOffenderIds.includes(offender.id),
  );
};
